import { render, staticRenderFns } from "./suggestionEntryCard.vue.html?vue&type=template&id=4ff7d3da&"
import script from "./suggestionEntryCard.ts?vue&type=script&lang=ts&"
export * from "./suggestionEntryCard.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports